import React, {useContext} from "react";
import {AppContext} from "../AppContext";

function LandingPage() {

    const { currentUser } = useContext(AppContext)

    return (
        <div>
            {!currentUser &&
               <center >
                    <h1>Welcome to EventBit!</h1>
                    <img src="/kap_scene_1.gif" alt="game preview"/>
                    <h3>Bringing fun to virtual events</h3>
                    <div className={"home-text"}>
                        <p>Eventbit is an event platform styled as a 2D game. Live attendees can explore the
                        space, attend video content sessions, and interact with other attendees over local chat
                            and video. We want to bring back some of the fun of being at a live event!
                             </p>
                    </div>
                    {/* <img src="/sample_dance.gif" alt="game dance"/> */}
                    <img src="/convo.gif" alt="game conversation"/>
                   <h3>Try it out</h3>
                   <div className={"home-text"}>
                       <p>Log in with one of the methods below. Once you log in, register for the
                           Tutorial event and go check it out!
                       </p>
                   </div>
               </center>
            }
        </div>
    )
}

export default LandingPage
